var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import { Stack, LinearProgress, Typography } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
const currentYear = new Date().getFullYear();
export default function AddSeasonDialog(_a) {
    var props = __rest(_a, []);
    const { enqueueSnackbar } = useSnackbar();
    const [cultures, setCultures] = React.useState([]);
    const [grades, setGrades] = React.useState([]);
    const [selectedCulture, setSelectedCulture] = React.useState(null);
    const [selectedGrade, setSelectedGrade] = React.useState(null);
    const [season, setSeason] = React.useState(currentYear);
    const [saving, setSaving] = React.useState(false);
    const getGradeCultureId = (g) => { var _a, _b, _c; return (_c = (_b = (_a = g.grade_culture) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : g.grade_culture_id) !== null && _c !== void 0 ? _c : g.culture_id; };
    const availableGrades = React.useMemo(() => grades.filter((g) => getGradeCultureId(g) === (selectedCulture === null || selectedCulture === void 0 ? void 0 : selectedCulture.id)), [grades, selectedCulture]);
    React.useEffect(() => {
        if (!props.open || !props.token)
            return;
        axios.get("/culture/list?limit=100&offset=0", {
            headers: { Authorization: `Bearer ${props.token}` }
        }).then(res => {
            var _a;
            if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.items)
                setCultures(res.data.items);
        });
        axios.get("/grade/list?limit=100&offset=0", {
            headers: { Authorization: `Bearer ${props.token}` }
        }).then(res => {
            var _a;
            if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.items)
                setGrades(res.data.items);
        }).catch(() => setGrades([]));
    }, [props.open, props.token]);
    React.useEffect(() => {
        if (selectedGrade && getGradeCultureId(selectedGrade) !== (selectedCulture === null || selectedCulture === void 0 ? void 0 : selectedCulture.id)) {
            setSelectedGrade(null);
        }
    }, [selectedCulture]);
    const destroy = () => {
        setSelectedCulture(null);
        setSelectedGrade(null);
        setSeason(currentYear);
        setSaving(false);
    };
    const create = () => {
        var _a;
        if (!selectedCulture)
            return;
        setSaving(true);
        axios.post("/field/season/create", {
            field_id: props.fieldId,
            season: season,
            culture_id: selectedCulture.id,
            grade_id: (_a = selectedGrade === null || selectedGrade === void 0 ? void 0 : selectedGrade.id) !== null && _a !== void 0 ? _a : null,
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${props.token}`
            }
        })
            .then((response) => {
            var _a, _b;
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) {
                enqueueSnackbar('Сезон добавлен', { variant: 'success', autoHideDuration: 1500 });
                destroy();
                props.setState(false);
                props.onCreated();
            }
            else {
                enqueueSnackbar(((_b = response.data) === null || _b === void 0 ? void 0 : _b.error) || 'Не удалось добавить сезон', { variant: 'error' });
                setSaving(false);
            }
        })
            .catch((reason) => {
            var _a, _b;
            let error = ((_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || reason.message;
            enqueueSnackbar(String(error), { variant: 'error' });
            setSaving(false);
        });
    };
    return (React.createElement(Dialog, { open: props.open, maxWidth: "xs", fullWidth: true, BackdropProps: { style: { backdropFilter: "blur(3px)" } } },
        React.createElement(DialogTitle, null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0435\u0437\u043E\u043D"),
        React.createElement(DialogContent, null,
            React.createElement(Stack, { spacing: 2, sx: { mt: 1 } },
                React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0443, \u0441\u043E\u0440\u0442 \u0438 \u0433\u043E\u0434 \u2014 \u043D\u0430 \u043F\u043E\u043B\u0435 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043D\u043E\u0432\u0430\u044F \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0430 \u0441\u0435\u0437\u043E\u043D\u0430."),
                React.createElement(TextField, { label: "\u0421\u0435\u0437\u043E\u043D (\u0433\u043E\u0434)", variant: "filled", type: "number", fullWidth: true, value: season, onChange: (e) => setSeason(parseInt(e.target.value) || currentYear) }),
                React.createElement(Autocomplete, { options: cultures, getOptionLabel: (option) => option.cultures_name, value: selectedCulture, onChange: (event, newValue) => setSelectedCulture(newValue), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { variant: "filled", label: "\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430", required: true }))) }),
                React.createElement(Autocomplete, { options: availableGrades, getOptionLabel: (option) => option.grade_name, value: selectedGrade, disabled: !selectedCulture, onChange: (event, newValue) => setSelectedGrade(newValue), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { variant: "filled", label: "\u0421\u043E\u0440\u0442", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043E\u0440\u0442" }))) }),
                saving && React.createElement(LinearProgress, null))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { disabled: !selectedCulture || !season || saving, onClick: create }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"),
            React.createElement(Button, { disabled: saving, onClick: () => { destroy(); props.setState(false); } }, "\u041E\u0442\u043C\u0435\u043D\u0430"))));
}
